import { render, staticRenderFns } from "./EnrollMFA.vue?vue&type=template&id=12a541e5"
import script from "./EnrollMFA.vue?vue&type=script&lang=js"
export * from "./EnrollMFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports